<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <Select v-model="search.siteMn" style="width: 7.8em" placeholder="请选择站点" clearable>
          <Option v-for="item in siteList" :value="item.mn" :key="item.mn">{{ item.name }}</Option>
        </Select>
        <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page
        :total="table.total"
        show-sizer
        @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)"
        style="text-align:right;margin-top: 1em"
      />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false" width="800">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="分组编号" prop="code">
          <i-input v-model="formValidate.code" @on-change="checkReCode" placeholder="请输入分组编号"></i-input>
        </FormItem>
        <FormItem label="分组名称" prop="name">
          <i-input v-model="formValidate.name" placeholder="请输入分组名称"></i-input>
        </FormItem>
        <Row v-for="(item, index) in formPortList" :key="item.id">
          <i-col span="8">
            <FormItem label="站点编号">
              <Select
                clearable
                style="margin-right: 20px;"
                @on-change="getDevice($event, item.id)"
                v-model="formValidate['aI' + index +'SiteMn']"
              >
                <Option v-for="prop in siteList" :key="prop.id" :value="prop.mn">{{ prop.name }}</Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem :label="item.simLabel">
              <Select
                clearable
                style="margin-right: 20px;"
                @on-change="deviceCheckFunc($event, index)"
                v-model="deviceCheckList[index]"
              >
                <Option
                  v-for="jtem in item.deviceList"
                  :key="jtem.id"
                  :disabled="deviceCheckList.indexOf(jtem.id) !=-1 ? true : false"
                  :value="jtem.id"
                >{{ jtem.name }}</Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="校准率">
              <i-input
                v-model="deviceNumberList[index]"
                @on-change="deviceNumberFunc(index)"
                placeholder="请输入校准率"
              ></i-input>
            </FormItem>
          </i-col>
        </Row>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>
    <!-- 提示对话框 -->
    <alert-p
      :modalAlert="alert.show"
      title="警告提醒"
      content="确定要删除吗？"
      @cansel="alert.show=false"
      @makeSure="delData"
      :modal_loading="alert.loading"
    ></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "编号",
            key: "code",
            align: "center"
          },
          {
            title: "名称",
            key: "name",
            align: "center"
          },
          {
            title: "aI0",
            key: "aI0DeviceName",
            align: "center"
          },
          {
            title: "aI1",
            key: "aI1DeviceName",
            align: "center"
          },
          {
            title: "aI2",
            key: "aI2DeviceName",
            align: "center"
          },
          {
            title: "aI3",
            key: "aI3DeviceName",
            align: "center"
          },
          {
            title: "aI4",
            key: "aI4DeviceName",
            align: "center"
          },
          {
            title: "aI5",
            key: "aI5DeviceName",
            align: "center"
          },
          {
            title: "aI6",
            key: "aI6DeviceName",
            align: "center"
          },
          {
            title: "aI7",
            key: "aI7DeviceName",
            align: "center"
          },
          {
            title: "操作",
            align: "center",
            width: 140,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        for (let i = 0, length = 8; i < length; i++) {
                          let siteMn = params.row["aI" + i + "SiteMn"];
                          if (siteMn) {
                            this.getDevice(siteMn, i + 1);
                            this.deviceCheckList[i] = params.row["aI" + i];
                            this.deviceNumberList[i] =
                              params.row["aIDetect" + i]; // 清空暂存系数
                          } else {
                            this.deviceCheckList[i] = null;
                            this.deviceNumberList[i] = null;
                          }
                        }
                        this.editCode = params.row.code; // 编辑时备份code(验证使用)
                        this.formValidate = {
                          id: params.row.id,
                          code: params.row.code, // 编号
                          name: params.row.name, // 名字
                          aI0: params.row.aI0, // 一号端口
                          aIDetect0: params.row.aIDetect0, // 一号校准
                          aI0SiteMn: params.row.aI0SiteMn || null, // 一号站点
                          aI1: params.row.aI1, // 二号端口
                          aIDetect1: params.row.aIDetect1, // 二号校准
                          aI1SiteMn: params.row.aI1SiteMn || null, // 二号站点
                          aI2: params.row.aI2, // 三号端口
                          aIDetect2: params.row.aIDetect2, // 三号校准
                          aI2SiteMn: params.row.aI2SiteMn || null, // 三号站点
                          aI3: params.row.aI3, // 四号端口
                          aIDetect3: params.row.aIDetect3, // 四号校准
                          aI3SiteMn: params.row.aI3SiteMn || null, // 四号站点
                          aI4: params.row.aI4, // 五号端口
                          aIDetect4: params.row.aIDetect4, // 五号校准
                          aI4SiteMn: params.row.aI4SiteMn || null, // 五号站点
                          aI5: params.row.aI5, // 六号端口
                          aIDetect5: params.row.aIDetect5, // 六号校准
                          aI5SiteMn: params.row.aI5SiteMn || null, // 六号站点
                          aI6: params.row.aI6, // 七号端口
                          aIDetect6: params.row.aIDetect6, // 七号校准
                          aI6SiteMn: params.row.aI6SiteMn || null, // 七号站点
                          aI7: params.row.aI7, // 八号端口
                          aIDetect7: params.row.aIDetect7, // 八号校准
                          aI7SiteMn: params.row.aI7SiteMn || null // 八号站点
                        };
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true
      },
      // 查询
      search: {
        siteMn: null
      },
      // 表单
      modal: {
        show: false,
        title: "添加"
      },
      // 表单数据
      formValidate: {
        // code: "", // 编号
        // name: "", // 名字
        // aI0: null, // 一号端口
        // aIDetect0: null, // 一号校准
        // aI1: null, // 二号端口
        // aIDetect1: null, // 二号校准
        // aI2: null, // 三号端口
        // aIDetect2: null, // 三号校准
        // aI3: null, // 四号端口
        // aIDetect3: null, // 四号校准
        // aI4: null, // 五号端口
        // aIDetect4: null, // 五号校准
        // aI5: null, // 六号端口
        // aIDetect5: null, // 六号校准
        // aI6: null, // 七号端口
        // aIDetect6: null, // 七号校准
        // aI7: null, // 八号端口
        // aIDetect7: null // 八号校准
      },
      // 验证
      ruleValidate: {
        code: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              /**
               * value            用户输入的值
               * callback(true)   检测失败，显示 message的内容
               * callback(new Error('手机号码格式不正确'))   检测失败，显示 error的内容
               * callback()       检测成功
               */
              if (this.editCode == value) {
                callback();
                return;
              }
              if (this.timer) {
                window.clearTimeout(this.timer);
              }
              this.timer = setTimeout(() => {
                this.$api.Deploy.getCheckCode({ content: { code: value } }, [
                  "uuid",
                  "common"
                ]).then(res => {
                  if (res.data) {
                    //说明重复
                    callback(true);
                  } else {
                    callback();
                  }
                });
              }, 300);
            },
            message: "code不能重复"
          }
        ],
        name: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          }
        ]
      },
      // 所有站点枚举列表
      siteList: [],
      // 所有设备枚举列表
      allDeviceList: [],
      // 端口模拟量数组
      formPortList: [
        {
          simLabel: "模拟量aI0",
          id: 1,
          deviceList: []
        },
        {
          simLabel: "模拟量aI1",
          id: 2,
          deviceList: []
        },
        {
          simLabel: "模拟量aI2",
          id: 3,
          deviceList: []
        },
        {
          simLabel: "模拟量aI3",
          id: 4,
          deviceList: []
        },
        {
          simLabel: "模拟量aI4",
          id: 5,
          deviceList: []
        },
        {
          simLabel: "模拟量aI5",
          id: 6,
          deviceList: []
        },
        {
          simLabel: "模拟量aI6",
          id: 7,
          deviceList: []
        },
        {
          simLabel: "模拟量aI7",
          id: 8,
          deviceList: []
        }
      ],
      // 暂存设备id列表
      deviceCheckList: [],
      // 暂存设备校准系数列表
      deviceNumberList: [],

      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
      // 定时器 检测code重复
      timer: null,
      editCode: null
    };
  },
  components: {
    toolbar
  },
  created() {
    this.getData(); // 数据初始化
    this.getAllDevice(); // 先获取所有设备
    this.getAllSite(); // 获取所有站点
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.deviceCheckList = []; // 清空暂存设备
      this.deviceNumberList = []; // 清空暂存系数
      this.formValidate = {
        // code: "", // 编号
        // name: "", // 名字
        // aI0: null, // 一号端口
        // aIDetect0: null, // 一号校准
        // aI1: null, // 二号端口
        // aIDetect1: null, // 二号校准
        // aI2: null, // 三号端口
        // aIDetect2: null, // 三号校准
        // aI3: null, // 四号端口
        // aIDetect3: null, // 四号校准
        // aI4: null, // 五号端口
        // aIDetect4: null, // 五号校准
        // aI5: null, // 六号端口
        // aIDetect5: null, // 六号校准
        // aI6: null, // 七号端口
        // aIDetect6: null, // 七号校准
        // aI7: null, // 八号端口
        // aIDetect7: null // 八号校准
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Deploy.getRtuList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Deploy.getRtuDel({ content: { id: id } }, ["uuid", "company"])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message ? res.message : "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Deploy.postRtuAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Deploy.postRtuEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    // 获取所有枚举设备
    getAllDevice() {
      this.$api.Enum.getDeviceEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          let data = res.data;
          let siteMap = {};
          data.map(item => {
            if (!siteMap[item.mn]) {
              siteMap[item.mn] = [];
              siteMap[item.mn].push(item);
            } else {
              siteMap[item.mn].push(item);
            }
          });
          this.allDeviceList = siteMap;
          //console.log(siteMap);
        }
      });
    },
    // 获取所有站点枚举
    getAllSite() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
        }
      });
    },
    // 表单操作 选择站点后获取设备
    getDevice(siteMn, id) {
      //console.log(siteMn, id);
      let data = this.formPortList;
      for (let i = 0, length = data.length; i < length; i++) {
        if (data[i].id == id) {
          data[i].deviceList = this.allDeviceList[siteMn];
          break;
        }
      }
    },
    // 选中设备后赋值表单
    deviceCheckFunc(deviceId, index) {
      //console.log(deviceId);
      this.formValidate["aI" + index] = deviceId || -1;
      this.deviceNumberList[index] = null;
    },
    // 校准率变化时更改
    deviceNumberFunc(index) {
      //console.log(this.deviceNumberList, index);
      this.formValidate["aIDetect" + index] = this.deviceNumberList[index];
    },
    // 判断rtu code全局是否重复
    checkReCode() {
      // this.$api.Deploy.getCheckCode({content: {code: this.formValidate.code}}, ["uuid", "common"]).then(res => {
      //   if(res.data) { //说明重复
      //   }
      // })
    }
  }
};
</script>